import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "../../../context/AuthContext";

const RequireRole = ({ role }) => {
  const { userRole } = useAuth();

  if (userRole && userRole !== role) {
    const target =
      userRole === "admin"
        ? "/admin"
        : userRole === "scout"
          ? "/scout/dashboard"
          : "/athlete/dashboard";
    return <Navigate to={target} replace />;
  }

  return <Outlet />;
};

export default RequireRole;
